import React from "react";
import { FiBell, FiUser } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { selectLanguage } from "../../../../store/languageSlice";

const MyProfile = ({ data, onClick }) => {
    const {t} = useSelector(selectLanguage)

    return (
        <div>
            <h3 className="pb-2 text-xl text-grey-700">{t.Switch_to_my_MR_Number}</h3>
            <div onClick={onClick} className="flex mt-2 justify-between items-center rounded-md p-4 max-w-md w-full bg-white">
                <div className="flex items-center gap-6 cursor-pointer">
                    <div className="bg-zinc-200 rounded-full w-12 h-12 flex justify-center items-center">
                        <FiUser className="w-6 h-6 text-gray-500" />
                    </div>
                    <div className="flex flex-col gap-1.5">
                        <h3 className="font-semibold text-lg text-gray-700 leading-4">{`${data.firstName} ${data.lastName}`}</h3>
                        <p className="ext-base leading-4 text-gray-700">
                        {data.mrn}
                        </p>
                        <p className="ext-base leading-4 text-gray-700">{t.Personal_Information}</p>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default MyProfile;